// extracted by mini-css-extract-plugin
export default {"wrapper":"GoalIcon_wrapper__rumb7"};